import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { serviceWorkerInitialState } from './constants';

const serviceWorkerSlice = createSlice({
  name: 'serviceWorker',
  initialState: serviceWorkerInitialState,
  reducers: {
    saveWaitingServiceWorker: (state, action: PayloadAction<ServiceWorker | null>) => {
      state.waitingServiceWorker = action.payload;
    },
  },
});

export const { saveWaitingServiceWorker } = serviceWorkerSlice.actions;

export default serviceWorkerSlice.reducer;
